export enum ChannelType {
  CATI = 'Cati',
  EMAIL = 'Mail',
  KIOSK = 'Kiosk',
  LINK = 'Link',
  MOBILE = 'Mobile',
  PUSH_NOTIFICATION = 'PushNotification',
  SMS = 'Sms',
  WEB_WIDGET = 'Web',
  WHATSAPP = 'Whatsapp',
  APP_STORE = 'AppStore',
  GOOGLE_PLAY = 'GooglePlay',
  IVR = 'Ivr',
  SIKAYET_VAR = 'SikayetVar',
  GLASSDOOR = 'Glassdoor',
  GOOGLE_MAP = 'GoogleMap',
  TRUSTPILOT = 'Trustpilot',
}
